const smoothScroll = (event, targetId) => {
    if (event) {
        event.preventDefault();
    }
    const targetElement = document.getElementById(targetId);
    if (targetElement) {
        targetElement.scrollIntoView({ behavior: 'smooth' });
    }
};

export default smoothScroll;
